import { EModelName } from './model-name';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

const ActionItemsSchema = new mongoose.Schema({
  user: {
    type: mongoose.Schema.Types.ObjectId,
    required: true,
    ref: EModelName.USER,
  },
  task: { type: String, required: true },
  description: { type: String },
  priority: { type: String, enum: ['High', 'Medium', 'Low'] },
  type: { type: String, enum: ['Commitment', 'Request'] },
  dueDate: { type: Date },
  source: { type: String },
  sourceEmail: { type: String },
  sourceScope: { type: String, enum: ['Internal', 'External', 'Unknown'] },
  subsource: { type: String },
  sourceToolId: { type: String, required: true },
  sourceTool: { type: String, enum: ['email', 'meeting'], required: true },
  created: { type: Date, default: Date.now() },
  closed: { type: Date },
  closedByUser: { type: Boolean },
});

export type T_ActionItems = InferSchemaType<typeof ActionItemsSchema> & {
  _id: string;
};

export type T_ActionItemsDocument = T_ActionItems & Document;

export { ActionItemsSchema };
